import React from 'react';
import { useTranslation } from 'react-i18next';
import ContentSearchResults from './ContentSearchResults/ContentSearchResults';
import UserSearchResults from './UserSearchResults/UserSearchResults';
import { FooterLink, FooterLinkModifier } from '../../molecules/FooterLink/FooterLink';
import { Namespace } from '../../../translation/namespace';
import { ContentBlockHeadline, ContentBlockHeadlineModifier } from '../../../_lib/components/ContentBlockHeadline';
import { ResultContent, ResultUser } from '../../../types/Search.types';
import { LoadMoreButtonType } from '../../../_lib/components/LoadMore/partials/LoadMoreButton';
import IUrl from '../../../types/IUrl';

type SearchResults = {
  blockLayout: string;
  searchListTemplate?: string;
  title?: string;
  searchResults?: {
    results: ResultContent[] | ResultUser[];
    loadMore?: LoadMoreButtonType;
  };
  allResultsUrl?: string;
  individualLinkName?: string;
  titleHidden?: boolean;
};

function isResultUserArray(results: ResultContent[] | ResultUser[] | undefined): results is ResultUser[] {
  return !!results && 'profileName' in results[0];
}

function isResultContentArray(results: ResultContent[] | ResultUser[] | undefined): results is ResultContent[] {
  return !!results && 'pageLink' in results[0];
}

/**
 * refactor this for specific blocks, checke where searchlist is used?
 * some blocks use only part of this component.
 *
 * This is the switch where we decide, what kind of search result we want to render: user or content.
 * Both can be table style layout or list which is depending on settings in UserSearchresults or ContentSearchResults.
 *
 * The headline is rendered, if there is a user input.
 * In a widget context it is not rendered, if the headline text is transferred to
 * WidgetHeader via React Context.
 */
export default function SearchResults({
  blockLayout,
  title,
  searchResults,
  allResultsUrl,
  individualLinkName,
  titleHidden,
  searchListTemplate,
}: SearchResults) {
  const { t } = useTranslation(Namespace.SearchResults);

  return (
    <>
      {searchResults && !titleHidden && (
        <ContentBlockHeadline title={title} modifier={ContentBlockHeadlineModifier.paddingBottom} />
      )}
      {searchResults?.results && searchResults.results.length > 0 && isResultUserArray(searchResults.results) ? (
        <UserSearchResults
          blockLayout={blockLayout}
          resultUsers={searchResults.results}
          loadMore={searchResults.loadMore}
        />
      ) : null}
      {searchResults?.results && searchResults.results.length > 0 && isResultContentArray(searchResults.results) ? (
        <ContentSearchResults
          blockLayout={blockLayout}
          resultContents={searchResults.results}
          originalSearchUrl={allResultsUrl}
          searchListTemplate={searchListTemplate}
          loadMore={searchResults.loadMore}
        />
      ) : null}
      <FooterLink
        modifier={FooterLinkModifier.PADDING_BOTTOM}
        footerButtonLabel={individualLinkName || t('toAllContents')}
        footerLink={{ url: allResultsUrl } as IUrl}
      />
    </>
  );
}
